import Axios from "axios";
import {
    getToken,
    removeToken
} from "../utils/auth";
import {
    TimeOut,
    PrevUrl,
    validStatus,
    SuccessCode
} from "../config/request"

class Base {
    PREV_PATH = PrevUrl;
    BASE_PATH = "";


    factoryAxios() {
        return Axios.create({
            timeout: TimeOut,
            headers: {
                token: getToken() + ""
            },
            validateStatus: (status) => {
                return validStatus.indexOf(status) >= 0
            }
        });
    }

    getUrl(url) {
        // console.log(this.PREV_PATH + this.BASE_PATH + url)
        return this.PREV_PATH + this.BASE_PATH + url;
    }

    hanldeResponse(response, resolve, reject) {
        if (response.status === 200) {
            if (response.data.code === SuccessCode) {
                resolve(response.data);
            } else {
                reject(response.data.message);
            }
        }

        if (response.status === 500) {
            reject(response.data.message ? response.data.message : "服务器出错")
        }

        if (response.status === 401) {
            removeToken()
            reject(response.data.message)
        }

    }

    hanldeError(error, reject) {
        reject(error);
    }

    runGet(url, params) {
        let instance = this.factoryAxios();

        return new Promise((resolve, reject) => {
            instance
                .get(this.getUrl(url), {
                    params: params
                })
                .then(res => {
                    this.hanldeResponse(res, resolve, reject);
                })
                .catch(e => {
                    this.hanldeError(e, reject);
                });
        });
    }

    runPost(url, data, params) {
        let instance = this.factoryAxios();
        return new Promise((resolve, reject) => {
            instance
                .post(this.getUrl(url), data, {
                    params: params
                })
                .then(res => {
                    this.hanldeResponse(res, resolve, reject);
                })
                .catch(e => {
                    this.hanldeError(e, reject);
                });
        });
    }

    runPut(url, data, params = {}) {
        let instance = this.factoryAxios();

        return new Promise((resolve, reject) => {
            instance
                .put(this.getUrl(url), data, {
                    params: params
                })
                .then(res => {
                    this.hanldeResponse(res, resolve, reject);
                })
                .catch(e => {
                    this.hanldeError(e, reject);
                });
        });
    }

    runDelete(url, data, params = {}) {
        let instance = this.factoryAxios();

        return new Promise((resolve, reject) => {
            instance
                .delete(this.getUrl(url), {
                    data: data,
                    params: params
                })
                .then(res => {
                    this.hanldeResponse(res, resolve, reject);
                })
                .catch(e => {
                    this.hanldeError(e, reject);
                });
        });
    }
}

export default Base;